import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Contractor } from 'model/Contractor';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import Modal, { modalStyle } from 'component/part/Modal';
import H2 from 'component/part/H2';

const ContractorShow: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const contractorId = parseInt(urlParams.id || '');
  const [contractor, setContractor] = useState<Contractor>();
  const [confirm, setConfirm] = useState(false);
  const [resultStatus, setResultStatus] = useState(0);

  const onSubmit = async () => {
    if (contractor) {
      const result = await api.contractor.delete(contractor.id);
      setConfirm(false);
      setResultStatus(result ? 1 : 2);
    }
  };

  const onUnderstoodResult = () => {
    setResultStatus(0);
    if (resultStatus === 1) {
      navigate('/contractor/list');
    }
  };

  useEffect(() => {
    (async () => {
      if (contractorId) {
        const contractorResponse = await api.contractor.get(contractorId);
        if (contractorResponse) {
          setContractor(contractorResponse);
        }
      }
    })();
  }, [contractorId]);

  return <Layout>
    <BackLink link='/contractor/list' label='元請情報一覧'></BackLink>
    <H2>業者情報</H2>
    <div css={generalStyle.form}>
      <FormContent label='元請名'>
        <div css={generalStyle.item()}>{contractor?.name || ''}</div>
      </FormContent>
      {contractor && (
        <div css={generalStyle.formRow}>
          <NavLink to={`/contractor/${contractor.id}/edit`} css={generalStyle.button()}>編集</NavLink>
          <button onClick={() => setConfirm(true)} css={generalStyle.button('warning')}>削除</button>
        </div>
      )}
    </div>
    <Modal display={confirm} onHide={() => setConfirm(false)}>
      <div>この元請業者を削除します</div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onSubmit} css={generalStyle.button()}>確定</button>
        <button onClick={() => setConfirm(false)} css={generalStyle.button('warning')}>キャンセル</button>
      </div>
    </Modal>
    <Modal display={!!resultStatus} onHide={onUnderstoodResult}>
      <div>
        {resultStatus === 1 ? '削除が完了しました' : '削除に失敗しました'}
      </div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onUnderstoodResult} css={generalStyle.button()}>OK</button>
      </div>
    </Modal>
  </Layout>;
};

export default ContractorShow;
